import "./App.css";
import About from "./components/about/About";
import Aksiya from "./components/aksiya/Aksiya";
import Carousel from "./components/carousel/Carousel";
import Contacts from "./components/contacts/Contacts";
import Footer from "./components/footer/Footer";
import Uploads from "./components/uploads/Uploads";
import Video from "./components/video/Video";
import Xod from "./components/Xod/Xod";

function App() {
  return (
    <>
      <Carousel />
      <About />

      <h2 className="my-5 fs-1 text-center">Акции</h2>
      <div className="container my-5">
        <hr className="divider" />
      </div>

      <div className="container">
        <div className="row">
          <div className="col-sm-6">
            {" "}
            <Aksiya
              aksiya_info={"Постоянная акция Дизайн квартиры в подарок"}
              aksiya_title={"Дизайн квартиры в подарок"}
              aksiya_body={
                "При покупке апартаментов в резиденции Mirabad Avenue, дизайн квартиры предоставляется в подарок. Акция действительна с 2019 года до окончания строительства третьей линии. Акция «Дизайн квартиры в подарок» предоставляется бюро Design House."
              }
              img="https://images.unsplash.com/photo-1472224371017-08207f84aaae?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
            />
          </div>
          <div className="col-sm-6">
            {" "}
            <Aksiya
              aksiya_info={"Постоянная акция Дизайн квартиры в подарок"}
              aksiya_title={"Дизайн квартиры в подарок"}
              aksiya_body={
                "При покупке апартаментов в резиденции Mirabad Avenue, дизайн квартиры предоставляется в подарок. Акция действительна с 2019 года до окончания строительства третьей линии. Акция «Дизайн квартиры в подарок» предоставляется бюро Design House."
              }
              img="https://images.unsplash.com/photo-1472224371017-08207f84aaae?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
            />
          </div>
        </div>
      </div>
      <Video />
      <Xod />
      <Uploads />
      <Contacts />
      <Footer />
    </>
  );
}

export default App;
